import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/components/Landing";
import Admin from "@/components/Admin";
import TheSetSpeaks from "@/components/TheSetSpeaks";
import BookedOutside from "@/components/BookedOutside";
import CategoryPage from "@/components/CategoryPage";
import NowCasting from "@/components/NowCasting";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/the-set-speaks" element={<TheSetSpeaks />} />
          <Route path="/booked-outside" element={<BookedOutside />} />
          {/* Dedicated NOW CASTING landing page (casting.automotoville.com) */}
          <Route path="/casting" element={<NowCasting />} />
          <Route path="/now-casting" element={<NowCasting />} />
          {/* New top-level category destination routes */}
          <Route path="/trucking" element={<CategoryPage />} />
          <Route path="/motorcycles" element={<CategoryPage />} />
          <Route path="/boating" element={<CategoryPage />} />
          <Route path="/cars" element={<CategoryPage />} />
          {/* Legacy /culture/:slug routes folded into CategoryPage */}
          <Route path="/culture/:slug" element={<CategoryPage />} />
          {/* Catch-all — any unknown path goes back home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
